/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businessaddedtoexistingaccount4Inputs */

const en_businessaddedtoexistingaccount4 = /** @type {(inputs: Businessaddedtoexistingaccount4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business added to the existing account; the owner was asked to sign in.`)
};

const de_businessaddedtoexistingaccount4 = /** @type {(inputs: Businessaddedtoexistingaccount4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen zum bestehenden Konto hinzugefügt; der Inhaber wurde zur Anmeldung aufgefordert.`)
};

/**
* | output |
* | --- |
* | "Business added to the existing account; the owner was asked to sign in." |
*
* @param {Businessaddedtoexistingaccount4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businessaddedtoexistingaccount4 = /** @type {((inputs?: Businessaddedtoexistingaccount4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businessaddedtoexistingaccount4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businessaddedtoexistingaccount4(inputs)
	return de_businessaddedtoexistingaccount4(inputs)
});
export { businessaddedtoexistingaccount4 as "businessAddedToExistingAccount" }